var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6332 28.9425C22.3913 28.9425 28.6805 22.5527 28.6805 14.6704C28.6805 6.78823 22.3913 0.398438 14.6332 0.398438C6.87512 0.398438 0.585938 6.78823 0.585938 14.6704C0.585938 22.5527 6.87512 28.9425 14.6332 28.9425Z",
    fill: "#2e2c48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8134 8H22.1135L17.0884 13.9303L23 22H18.3713L14.7459 17.1057L10.5977 22H8.2962L13.671 15.6569L8 8H12.7462L16.0232 12.4735L19.8134 8ZM19.0061 20.5785H20.2806L12.0537 9.34687H10.686L19.0061 20.5785Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTw);
export default __webpack_public_path__ + "static/media/icon-tw.c50ab1af98eb0f490816cef7a67ff87f.svg";
export { ForwardRef as ReactComponent };